/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Nofiles1Inputs */

const zh_sidebar_nofiles1 = /** @type {(inputs: Sidebar_Nofiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无文件`)
};

const en_sidebar_nofiles1 = /** @type {(inputs: Sidebar_Nofiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files yet`)
};

const es_sidebar_nofiles1 = /** @type {(inputs: Sidebar_Nofiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin archivos`)
};

/**
* | output |
* | --- |
* | "No files yet" |
*
* @param {Sidebar_Nofiles1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_nofiles1 = /** @type {((inputs?: Sidebar_Nofiles1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Nofiles1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_nofiles1(inputs)
	if (locale === "en") return en_sidebar_nofiles1(inputs)
	return es_sidebar_nofiles1(inputs)
});
export { sidebar_nofiles1 as "sidebar_noFiles" }